import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleDownMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconChevronTriangleDownMedium"><Path d="M15.8825 9C16.9467 9 17.524 10.2452 16.8366 11.0576L12.9538 15.6465C12.4544 16.2362 11.5448 16.2363 11.0456 15.6465L7.16276 11.0576C6.47564 10.2453 7.05295 9.00027 8.11686 9H15.8825Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleDownMedium;
